import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import Spinner from "../../../../../../Components/common/Spinner/Spinner";
import ExpandOrShrinkIcon from "../../../../../../Components/UI/DropDown/ExpandOrShrinkIcon";
import DetailButton from "../../DetectionDetailPopup/DetailButton";
import useDetectionDetailPopup from "../../DetectionDetailPopup/useDetectionDetailPopup";

import { RequestAgentSigmaOutput } from "../../../../../../store/actions/integrationsActions";

const SigmaOutputSection = ({ ruleKey, expanded, setExpanded }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { findDetailByOutputMatch, openDetail, popup } = useDetectionDetailPopup();

  const sigmaOutput = useSelector((state) => state.integrations.agentSigmaOutput);
  const loading = useSelector((state) => state.integrations.agentSigmaOutputLoading);

  const query = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  const originalId = query.get("data");

  useEffect(() => {
    if (!expanded || !ruleKey) return;
    dispatch(RequestAgentSigmaOutput({ originalId, ruleKey }));
  }, [dispatch, expanded, originalId, ruleKey]);

  return (
    <div className="thunter-threat-details__content__output">
      <button
        className="thunter-threat-details__tab-button thunter-threat-details__tab-button__active thunter-threat-details__content__output__toggle"
        title={expanded ? "Hide output" : "Show output"}
        onClick={() => setExpanded((prevValue) => !prevValue)}>
        {expanded ? null : "Output"} <ExpandOrShrinkIcon expanded={expanded} collapsed={false} />
      </button>
      {expanded ? (
        <div className="thunter-threat-details__content__output__list">
          {loading ? (
            <Spinner width={24} height={24} />
          ) : sigmaOutput.length === 0 ? (
            <p className="thunter-threat-details__content__output__no-data">No data</p>
          ) : (
            sigmaOutput.map((output, i) => {
              const matchDetail = findDetailByOutputMatch(output);

              return (
                <div key={i} className="thunter-threat-details__content__bottom">
                  <div className="thunter-threat-details__table-button-block">
                    <button className="thunter-threat-details__tab-button thunter-threat-details__tab-button__active">
                      Match #{i + 1}
                    </button>
                    {matchDetail ? (
                      <DetailButton
                        title="Show file/process details"
                        onClick={() => openDetail(matchDetail)}
                      />
                    ) : null}
                  </div>
                  <div className="details-block">
                    {Object.entries(output).map(([key, value], idx) => (
                      <div className="details-block__row" key={idx}>
                        <p className="details-block__row-item">{key}</p>
                        <p className="details-block__row-item">{value || "-"}</p>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })
          )}
        </div>
      ) : null}

      {popup}
    </div>
  );
};

export default SigmaOutputSection;
